import { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Card, CardContent } from '../ui/card';
import { Users, Database, Mail, Send, MailOpen, MousePointerClick, AlertTriangle, UserMinus } from 'lucide-react';

const STATS = [
  { key: 'total_reach', label: 'Total Reach', icon: Users, color: 'text-navy' },
  { key: 'crm_contacts', label: 'CRM Contacts (source of truth)', icon: Database, color: 'text-magenta' },
  { key: 'newsletter_subscribers', label: 'Newsletter Subscribers', icon: Mail, color: 'text-emerald-600' },
  { key: 'campaigns_sent', label: 'Campaigns Sent', icon: Send, color: 'text-sky-600' },
  { key: 'open_rate', label: 'Open Rate', icon: MailOpen, color: 'text-indigo-600', pct: true },
  { key: 'click_rate', label: 'Click Rate', icon: MousePointerClick, color: 'text-amber-600', pct: true },
  { key: 'bounce_rate', label: 'Bounce Rate', icon: AlertTriangle, color: 'text-orange-600', pct: true },
  { key: 'unsubscribes', label: 'Unsubscribes', icon: UserMinus, color: 'text-red-500' },
];

export default function CommsOverview() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/comms/dashboard').then((r) => setData(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-4" data-testid="comms-overview">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {STATS.map((s) => (
          <Card key={s.key} data-testid={`comms-stat-${s.key}`}>
            <CardContent className="p-5">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-xs text-slate-500 font-medium">{s.label}</div>
                  <div className="text-2xl font-bold text-navy mt-1">
                    {data ? (s.pct ? `${data[s.key]}%` : data[s.key]) : '—'}
                  </div>
                </div>
                <s.icon className={`w-5 h-5 ${s.color}`} />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      <p className="text-xs text-slate-400">
        Campaign recipients are pulled live from the CRM plus external newsletter subscribers — no duplicate contact database. Open/click rates populate via the Resend webhook after production setup.
      </p>
    </div>
  );
}
